import { setCurrentDate } from 'app/actions/session';
import Router from 'app/router';
import { useAsyncAction, useInterval } from 'app/services';
import { sessionCheckOut } from 'app/store/session';
import { theme, ThemeProvider, ThemeStyles } from 'app/theme';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const App = () => {
    const dispatch = useDispatch();
    const { currentDate } = useSelector((state) => state.session);
    const [isLoading, setIsLoading] = useState(true);

    const { asyncAction: checkSubmit, isLoading: isCheckLoading, isSuccessful: isCheckSuccessful, isError: isCheckError } = useAsyncAction(sessionCheckOut);

    // Сменим дату в 00:00:00.
    useInterval(() => {
        if (moment().isAfter(currentDate, 'day')) {
            dispatch(setCurrentDate(moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')));
        }
    }, 1000);

    useEffect(() => {
        if (!isCheckLoading && (isCheckSuccessful || isCheckError)) {
            setIsLoading(false);
        }
    }, [isCheckLoading, isCheckSuccessful, isCheckError]);

    // Проверим сеанс пользователя при монтировании и
    // изменим статус загрузки маршрутизатора.
    useEffect(() => {
        checkSubmit();
    }, []);

    return (
        // Этот компонент принимает свойство темы и делает
        // его доступным в дереве React благодаря контексту.
        <ThemeProvider theme={theme}>
            <ThemeStyles />
            <Router isLoading={isLoading} />
        </ThemeProvider>
    );
};

export default App;
